import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { articles } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const ArticlesCategoriesLoader = ({
  children,
  fetchArticlesCategories,
  activeLanguage: { code: locale },
  ...restProps
}) => (
  <Loader
    fetchMethod={() => fetchArticlesCategories({ locale })}
    triggers={[locale]}
    {...restProps}
  >
    {children}
  </Loader>
)

ArticlesCategoriesLoader.propTypes = {
  children: PropTypes.node.isRequired,
  fetchArticlesCategories: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
}

export default compose(
  connect(
    null,
    { fetchArticlesCategories: articles.fetchArticlesCategories }
  ),
  withLocalize
)(ArticlesCategoriesLoader)
